import creative_status from "dictionaries/creative_status.json";
import chunk from "lodash/chunk";
import { CreativeShortV2 } from "models";
import {ReactNode, useState} from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { Pagination } from "ui";
import StatusCell from "ui/StatusDisplay/StatusCell";
import getLastPageNumber from "utils/getLastPageNumber";
import getTextShortened from "utils/getTextShortened";
type Props = {
  isOpen: boolean;
  toggle: () => void;
  creatives: CreativeShortV2[] | undefined;
  label: string | number | undefined;
};

const CreativesModal = ({ isOpen, toggle, creatives, label }: Props) => {
  const creativesChunks = chunk(creatives, 10);
  const [currentPage, setCurrentPage] = useState(0);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="p-0 modal-shadow-none">
      <ModalHeader toggle={toggle}>Креативы группы {label}</ModalHeader>
      <ModalBody>
        {creatives && creatives.length ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Наименование креатива</th>
                <th>Токен креатива</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {creativesChunks[currentPage].map((creative) => {
                const creativeTitle = getTextShortened(
                  creative.title ||
                    creative.medias?.[0].file_url?.split("/").at(-1) ||
                    creative.medias?.[0]?.file_path?.split("/").at(-1) ||
                    creative.texts?.[0]?.text ||
                    "",
                  25
                );

                return (
                  <tr key={creative.id}>
                    <td>{creative.id}</td>
                    <td>{creativeTitle}</td>
                    <td>{creative.marker}</td>
                    <StatusCell data={creative} dictionary={creative_status} />
                  </tr>
                );
              })}
            </tbody>
          </Table> as ReactNode
        ) : (
          <p>Нет креативов</p> as ReactNode
        )}
      </ModalBody>
      {getLastPageNumber(creatives?.length || 0, 10) > 1 && (
        <ModalFooter className="d-flex justify-content-center">
          <Pagination
            currentPage={currentPage}
            lastPageNumber={getLastPageNumber(creatives?.length || 0, 10)}
            setCurrentPage={setCurrentPage}
          />
        </ModalFooter> as ReactNode
      )}
    </Modal>
  );
};

export default CreativesModal;
